import Icon from "components/atoms/Icon";
import Text from "components/atoms/Text";
import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface CompareBlockProps {
  count?: number;
  detailPosition?: boolean;
  topPosition?: string;
}

const CompareBlock: React.FC<CompareBlockProps> = ({
  count,
  detailPosition,
  topPosition,
}: CompareBlockProps) => {
  const ORIGINAL_CLASS = "m-compareblock";

  return (
    <div
      {...(topPosition
        ? {
            style: {
              top: topPosition,
            },
          }
        : {})}
      className={joinClassnames(ORIGINAL_CLASS, detailPosition && "detail")}
    >
      <div className={`${ORIGINAL_CLASS}_icon`}>
        <Icon iconName="compare-block" />
      </div>
      <Text size="sm" modifiers={["white"]} weight="bold">
        So sánh {count && `(${count})`}
      </Text>
    </div>
  );
};

export default CompareBlock;
